export default __webpack_public_path__ + "a8e65d9f197b8a218bb1a270d7dac76e.svg";